/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

*/

// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState ,fixed, alertHeight}) => {
  const { palette, boxShadows, transitions, breakpoints, functions } = theme;
  const { transparentSidenav, whiteSidenav, miniSidenav, darkMode } = ownerState;

  const sidebarWidth = 250;
  const { transparent, gradients, white, background } = palette;
  const { xxl } = boxShadows;
  const { pxToRem, linearGradient } = functions;

  let backgroundValue = darkMode
    ? background.sidenav
    : linearGradient(gradients.dark.main, gradients.dark.state);

  if (transparentSidenav) {
    backgroundValue = transparent.main;
  } else if (whiteSidenav) {
    backgroundValue = white.main;
  }

  const heightAdjustment = `calc(95% - ${alertHeight}px)`
  const topPosition = fixed ? "0" : `${alertHeight}px`;

  // styles for the sidenav when miniSidenav={false}
  const drawerOpenStyles = () => ({
    position: fixed ? "fixed" : "absolute",
    left: 0,
    top:fixed? 0 : topPosition,
    height:heightAdjustment,
    background: backgroundValue,
    display: "flex",
    flexDirection: "column", // 确保内容区和底部区分
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xxl")]: {
      boxShadow: transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: sidebarWidth,
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  // styles for the sidenav when miniSidenav={true}
  const drawerCloseStyles = () => ({
    position: fixed ? "fixed" : "absolute",
    left: 0,
    top:fixed? 0 : topPosition,
    height:heightAdjustment,
    background: backgroundValue,
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xxl")]: {
      boxShadow: transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: pxToRem(70),
      overflowX: "hidden",
      transform: "translateX(0)",
      // transition: transitions.create(["width", "background-color"], {
      //   easing: transitions.easing.easeInOut,
      //   duration: transitions.duration.shorter,
      // }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      boxShadow: xxl,
      border: "none",
      display: "flex",
      flexDirection: "column", // 确保内容和底部分离
      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
